import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Route, Switch, Redirect, BrowserRouter,
} from 'react-router-dom';

import auth from './utils/auth';
import { routes } from './routes';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import WithSidebar from './components/WithSidebar';
import CheckerContainer from './components/Checker/CheckerContainer';

const App = props => (
  <div>
    <BrowserRouter>
      <Switch>
        {routes.map(route => (
          <Route
            key={route.id}
            {...route}
            render={(routeProps) => {
              const { authRequired, componentToRender: ComponentToRender } = route;
              let toRender = <div />;

              // If auth is not required, just render the route without checking for token
              if (!authRequired) {
                toRender = <ComponentToRender {...routeProps} />;
              } else {
                // If auth is required, check if there is a token, if not redirect to Login.
                toRender = auth.isRouteAccessPermitted(authRequired) ? (
                  <Redirect to="/login" />
                )
                  : (
                    <ComponentToRender {...routeProps} />
                  );
              }

              if (route.noSidebar) {
                return (
                  <Fragment>{toRender}</Fragment>
                );
              }

              return (
                <CheckerContainer>
                  {route.access === 'all' || (props.user && route.access.includes(props.user.role))
                    ? (
                      <WithSidebar {...routeProps}>
                        {toRender}
                      </WithSidebar>
                    )
                    : <p>no access</p>
                  }
                </CheckerContainer>
              );
            }}
          />
        ))}
      </Switch>
    </BrowserRouter>
  </div>
);

App.propTypes = {
  user: PropTypes.shape({
    role: PropTypes.string,
  }),
};

App.defaultProps = {
  user: {},
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js